module.exports = "<ul class=\"nav rm-menu\">\n  <li class=\"nav-item\">\n    <a class=\"nav-link\" scrollTo href=\"#rm-about\">About</a>\n  </li>\n  <li class=\"nav-item\">\n    <a class=\"nav-link\" scrollTo href=\"#rm-education\">Education</a>\n  </li>\n  <li class=\"nav-item\">\n    <a class=\"nav-link\" scrollTo href=\"#rm-portfolio\">Portfolio</a>\n  </li>\n  <li class=\"nav-item\">\n    <a class=\"nav-link\" scrollTo href=\"#rm-contact\">Contact</a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/menu/menu.component.html
// module id = ../../../../../src/app/menu/menu.component.html
// module chunks = main